export const CMS_API_URL = process.env.REACT_APP_CMS_API_URL || 'http://localhost:8085/v1/cms';
export const CMS_COMMON_API_URL = process.env.REACT_APP_COMMON_API_URL || 'http://localhost:8085/v1';
export const LOCK_CONTAINER_ID = 'auth0lock';
export const USER_PERMISSIONS_KEY = 'https://formelife.com/permissions';
export const AUTH0_REDIRECT_URL = window.location.origin;
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || 'dash-auth.ci.formelife.net';
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID || 'swM4FZazf0AjqoerS1iUYHL2YPJcLBhp';
export const CMS_APP_VERSION = process.env.REACT_APP_VERSION;
